import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionEs = () => {
  return (
    <section className="app-section">
      <h1>Cómo instalar Tango: guía paso a paso</h1>
      <h5>¡En Vivo. Conéctate. Disfruta – En cualquier momento, en cualquier lugar!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>Escrito por Tango</span>
          <span>Actualizado ayer</span>
        </div>
      </div>
      <p>
        <b>
          Tango está disponible en múltiples plataformas, lo que facilita transmitir en vivo y disfrutar del entretenimiento en vivo en cualquier momento y lugar.
        </b>
      </p>
      <hr />
      <h2>🤖 Para usuarios de Android</h2>
      <p>
        Puedes descargar Tango directamente desde:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <br />
      <h2> Para dispositivos iOS:</h2>
      <p>
        <b>
          Si anteriormente instalaste Tango en tu dispositivo iOS, puedes volver a descargarlo desde la App Store.
        </b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <b>1. Abre la App Store:</b> Ingresa a la App Store en tu dispositivo iOS.
      </p>
      <p>
        <b>2. Toca tu foto de perfil:</b> En la esquina superior derecha de la pantalla para abrir la configuración de tu cuenta.
      </p>
      <p>
        <b>3. Ve a 'Apps' o 'Historial de compras':</b> Revisa la lista de aplicaciones que compraste previamente o usa la barra de búsqueda en la parte superior para buscar "Tango".
      </p>
      <p>
        <b>4. Vuelve a descargar Tango:</b> Una vez que encuentres Tango en la lista, toca el ícono de la nube con una flecha para volver a descargar la aplicación.
      </p>
      <p>
        Abre la aplicación de Tango después de la instalación y sigue el proceso de registro o inicio de sesión.
      </p>
      <hr />
      <h2>¿Eres nuevo en Tango? Agrega Tango fácilmente a la pantalla de inicio de tu dispositivo para un acceso rápido</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        Abre el sitio web de Tango: Ingresa al enlace <a href="https://tango.me">https://tango.me</a> en el navegador de tu móvil.
      </p>
      <p>
        Toca el ícono de compartir: El cuadrado con una flecha hacia arriba en la parte inferior de la pantalla.
      </p>
      <p>
        Selecciona "Agregar a la pantalla de inicio": En el menú, y se agregará el acceso directo de Tango a la pantalla de inicio de tu dispositivo.
      </p>
      <p>​Una vez instalado, estarás listo para transmitir en vivo, apoyar a tus creadores favoritos y disfrutar de entretenimiento sin fin, ¡todo al alcance de tus manos!</p>
      <br/>
      <b>¡Comienza ahora y únete a la acción! 🎉</b>
    </section>
  );
};

export default SectionEs;
